/**
 * Format a raw OPC UA value with precision and enum mapping.
 * Shared between REST mapper (initial load) and WebSocket handler (live updates).
 */
export function formatRawValue(
  value: unknown,
  precision?: number,
  enumStrings?: string[]
): string | number {
  if (value === undefined || value === null) return "-";

  if (enumStrings && Array.isArray(enumStrings)) {
    const index = Number(value);
    if (Number.isInteger(index) && index >= 0 && index < enumStrings.length) {
      return enumStrings[index];
    }
  }

  if (
    typeof value === "number" &&
    precision !== undefined &&
    Number.isInteger(precision)
  ) {
    return value.toFixed(precision);
  }

  return value as string | number;
}
